import GroupPermissionsSection from './GroupPermissionsSection'
export default GroupPermissionsSection
